var API_DOMAIN = "https://kalaicrackersbilling.zentexus.in/api";

export default API_DOMAIN;
